<template>
  <v-container fluid class="volume-detail" v-if="volume">
    <v-row class="flex-grow-0">
      <v-btn
        text
        x-small
        color="primary"
        exact
        :to="{ name: 'sor-detail', params: { sorId: $route.params.sorId } }"
      >
        &lt;&lt; {{ volume.sor.name }}
      </v-btn>
    </v-row>

    <v-row class="sor-info-wrapper">
      <v-col>
        <div class="sor-info">
          <h3>{{ volume.name }}</h3>
          <div>{{ $t("sor.edition") }}: {{ volume.sor.edition.id }}</div>
          <div>{{ $t("sor.not_available_for_sale") }}</div>
        </div>
      </v-col>
    </v-row>
    <v-row class="flex-grow-0" v-if="volume.finalised_at">
      <v-col>
        <v-btn color="primary" @click="$downloadFile(volume.finalised_pdf)">
          {{ $t("sor.download_pdf") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row
      class="flex-grow-0 sor-action-input-disable-row mb-2 rounded"
      v-if="!volume.finalised_at"
    >
      <v-col>
        <span class="font-weight-bold mr-8">{{ $t("sor.action_input") }}</span>
        {{ $t("sor.action_input_not_available") }}
      </v-col>
    </v-row>
    <v-row
      class="flex-grow-0 sor-action-input-row mb-2 rounded elevation-4"
      v-if="volume.finalised_at"
    >
      <v-col cols="12" class="d-flex">
        <span class="font-weight-bold">{{ $t("sor.action_input") }}</span>
        <v-btn
          color="primary"
          small
          class="ml-4"
          v-if="$store.getters.hasPermission(PERMISSIONS.MANAGE_SOR)"
          :disabled="!volume.action_input"
          @click="regenActionInput"
        >
          {{ $t("regenerate") }}
        </v-btn>
        <v-btn
          color="primary"
          small
          class="ml-4"
          v-if="$store.getters.hasPermission(PERMISSIONS.MANAGE_SOR)"
          :disabled="!volume.action_input"
          @click="$downloadFile(volume.action_input.id)"
        >
          {{ $t("sor.download_action_input") }}
        </v-btn>
        <v-btn
          color="primary"
          small
          class="ml-4"
          v-if="$store.getters.hasPermission(PERMISSIONS.INPUT_SOR)"
          :disabled="!volume.action_input || volume.action_input_finalised_at"
          @click="importActionInput"
        >
          {{ $t("sor.import_action_input") }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          small
          class="ml-4"
          v-if="
            $store.getters.hasPermission(PERMISSIONS.MANAGE_SOR) &&
            volume.action_input &&
            !volume.action_input_finalised_at
          "
          @click="finaliseActionInput"
        >
          {{ $t("sor.finalise") }}
        </v-btn>
        <!--        <v-btn color="primary"-->
        <!--               small-->
        <!--               class="ml-4"-->
        <!--               v-if="$store.getters.hasPermission(PERMISSIONS.MANAGE_SOR) && volume.action_input && volume.action_input_finalised_at"-->
        <!--               @click="unfinaliseActionInput">-->
        <!--          {{ $t('sor.un_finalise') }}-->
        <!--        </v-btn>-->
      </v-col>
      <v-col cols="12" class="pa-0">
        <v-data-table
          :items="actionItems"
          :headers="actionHeaders"
          hide-default-footer
        >
          <template #no-data>
            {{ $t("sor.action_input_being_generated") }}
          </template>
          <template #item.created_at="{ value }">
            {{ $parseDate(value) }}
          </template>
          <template #item.finalised_at>
            {{
              volume.action_input_finalised_at
                ? $parseDate(volume.action_input_finalised_at)
                : ""
            }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-row class="flex-grow-0 sor-action-input-row mb-2 rounded elevation-4">
      <v-col cols="12" class="d-flex">
        <span class="font-weight-bold">{{ $t("volume.cover_pdf") }}</span>
        <v-btn
          color="primary"
          small
          class="ml-4"
          v-if="
            $store.getters.hasPermission(PERMISSIONS.INPUT_SOR) &&
            !volume.finalised_at
          "
          @click="uploadCoverPdf"
        >
          <v-icon>fas fa-plus</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" class="pa-0">
        <v-data-table
          :items="coverPdfItems"
          :headers="coverPdfHeaders"
          hide-default-footer
        >
          <template #item.created_at="{ value }">
            {{ $parseDate(value) }}
          </template>
          <template #item.finalised_at>
            {{
              volume.action_input_finalised_at
                ? $parseDate(volume.action_input_finalised_at)
                : ""
            }}
          </template>
          <template #item.actions="{ item }">
            <v-btn text color="primary" @click="$downloadFile(item.id)">
              {{ $t("download") }}
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-row class="flex-grow-0 sor-detail-section-title rounded-t pa-3">
      <span class="font-weight-bold">{{ $t("section.title") }}</span>
      <v-btn
        color="primary"
        small
        class="ml-4"
        v-if="
          $store.getters.hasPermission(PERMISSIONS.INPUT_SOR) &&
          !volume.finalised_at
        "
        @click="importSection"
      >
        <v-icon key="importSection">fas fa-plus</v-icon>
      </v-btn>

      <span class="sor-finalised-div" v-if="volume.finalised_at">
        {{ $t("sor.finalised") }}
        <v-icon color="#5BC23F" small>mdi-check</v-icon>
      </span>
      <v-spacer></v-spacer>
      <v-btn color="primary" small class="ml-4" @click="refresh">
        <v-icon small>fas fa-sync-alt</v-icon>
      </v-btn>
      <v-btn
        color="primary"
        small
        class="ml-4"
        v-if="
          $store.getters.hasPermission(PERMISSIONS.MANAGE_SOR) &&
          !volume.finalised_at
        "
        @click="finaliseVolume"
      >
        {{ $t("sor.finalise") }}
      </v-btn>
      <!--      <v-btn color="primary"-->
      <!--             small-->
      <!--             class="ml-4"-->
      <!--             v-if="$store.getters.hasPermission(PERMISSIONS.MANAGE_SOR) && volume.finalised_at"-->
      <!--             :disabled="volume.action_input_finalised_at"-->
      <!--             @click="unfinaliseVolume">-->
      <!--        {{ $t('sor.un_finalise') }}-->
      <!--      </v-btn>-->
      <v-btn
        color="primary"
        small
        class="ml-4"
        v-if="
          $store.getters.hasPermission(PERMISSIONS.MANAGE_SOR) &&
          !volume.finalised_at
        "
        @click="preAllSections"
      >
        {{ $t("volume.preview_all") }}
      </v-btn>
      <v-btn
        color="primary"
        small
        class="ml-4"
        v-if="$store.getters.hasPermission(PERMISSIONS.MANAGE_SOR)"
        @click="downloadAllExcels"
      >
        {{ $t("volume.download_all_excels") }}
      </v-btn>
    </v-row>
    <v-row class="flex-grow-1 rounded-b">
      <SectionList
        full-height
        :edition-id="$route.params.editionId"
        :sor-id="$route.params.sorId"
        :volume-id="$route.params.volumeId"
        :refresh-trigger.sync="refreshTrigger"
        :sor-finalised="!!volume.finalised_at"
      ></SectionList>
    </v-row>
  </v-container>
</template>

<script>
import { computed, onMounted, ref } from "@vue/composition-api";
import SorList from "@/components/sor/SorList";
import { ACTION_TYPES } from "@/store/types";
import SectionList from "@/components/section/SectionList";
import ImportSectionDialog from "@/components/section/ImportSectionDialog";
import ImportActionInputDialog from "@/components/sor/ImportActionInputDialog";
import { PERMISSIONS } from "@/constants";
import AllSectionPreviewModal from "@/components/section/AllSectionPreviewModal";
import ImportVolumeCoverPdfDialog from "@/components/volume/ImportVolumeCoverPdfDialog";

export default {
  name: "Volume",
  components: { SectionList, SorList },
  setup(props, { root }) {
    const volume = ref(null);
    const getVolume = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/volume/",
        params: { volume_id: root.$route.params.volumeId },
      });

      if (response.body.success) {
        volume.value = response.body.volume;
      }
    };

    const actionItems = computed(() => {
      if (volume.value && volume.value.action_input) {
        return [volume.value.action_input];
      }

      return [];
    });
    const actionHeaders = ref([
      {
        text: root.$t("action_input.created_at"),
        value: "created_at",
        width: 150,
      },
      { text: root.$t("action_input.filename"), value: "filename" },
      {
        text: root.$t("action_input.finalised_at"),
        value: "finalised_at",
        width: 150,
      },
    ]);
    const regenActionInput = async function () {
      if (
        await root.$dialog.confirm({
          text: root.$t("sor.regen_action_input_confirm_msg"),
        })
      ) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/volume/regen_action/",
          params: { volume_id: root.$route.params.volumeId },
        });

        if (response.body.success) {
          await getVolume();
        }
      }
    };
    const downloadActionInput = function () {};
    const importActionInput = async function () {
      await root.$dialog.showAndWait(ImportActionInputDialog, {
        volumeId: root.$route.params.volumeId,
        showClose: false,
        persistent: true,
      });
      await getVolume();
    };
    const finaliseActionInput = async function () {
      if (
        await root.$dialog.confirm({
          text: root.$t("sor.finalise_action_input_confirm_msg"),
        })
      ) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/volume/finalise_action_input/",
          params: { volume_id: root.$route.params.volumeId },
        });

        if (response.body.success) {
          await getVolume();
        }
      }
    };
    const unfinaliseActionInput = async function () {
      if (
        await root.$dialog.confirm({
          text: root.$t("sor.unfinalise_action_input_confirm_msg"),
        })
      ) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/volume/unfinalise_action_input/",
          params: { volume_id: root.$route.params.volumeId },
        });

        if (response.body.success) {
          await getVolume();
        }
      }
    };

    const coverPdfItems = computed(() => {
      if (volume.value && volume.value.cover_pdf) {
        return [volume.value.cover_pdf];
      }

      return [];
    });
    const coverPdfHeaders = ref([
      { text: "Last Update", value: "created_at", width: 150 },
      { text: "Filename", value: "filename" },
      { text: "Finalised At", value: "finalised_at", width: 150 },
      { text: "", value: "actions", width: 150 },
    ]);
    const uploadCoverPdf = async function () {
      await root.$dialog.showAndWait(ImportVolumeCoverPdfDialog, {
        volumeId: root.$route.params.volumeId,
        showClose: false,
        persistent: true,
      });
      await getVolume();
    };

    const importSection = async function () {
      const result = await root.$dialog.showAndWait(ImportSectionDialog, {
        sorId: root.$route.params.sorId,
        volumeId: root.$route.params.volumeId,
        showClose: false,
        persistent: true,
        width: 640,
      });

      if (result === true) {
        refresh();
      }
    };
    const finaliseVolume = async function () {
      if (
        await root.$dialog.confirm({
          text: root.$t("sor.finalise_confirm_msg"),
        })
      ) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/volume/finalise/",
          params: { volume_id: root.$route.params.volumeId },
        });

        if (response.body.success) {
          await getVolume();
        }
      }
    };
    const unfinaliseVolume = async function () {
      if (
        await root.$dialog.confirm({
          text: root.$t("sor.un_finalise_confirm_msg"),
        })
      ) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/volume/unfinalise/",
          params: { volume_id: root.$route.params.volumeId },
        });

        if (response.body.success) {
          await getVolume();
        }
      }
    };

    const preAllSections = async function () {
      await root.$dialog.showAndWait(AllSectionPreviewModal, {
        sorId: volume.value.sor.id,
        volumeId: volume.value.id,
        width: "70vw",
        showClose: false,
        persistent: true,
        scrollable: true,
      });

      refresh();
    };
    const downloadAllExcels = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/volume/download_all_excels/",
        params: { volume_id: root.$route.params.volumeId },
        opt: { extra: { responseType: "arraybuffer" } },
      });

      let blob = new Blob([response.data], {
        type: response.headers.get("content-type"),
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = decodeURI(response.headers.get("content-filename"));
      link.click();
    };

    const refreshTrigger = ref(false);
    const refresh = function () {
      refreshTrigger.value = !refreshTrigger.value;
    };

    onMounted(() => {
      getVolume();
    });

    return {
      volume,

      actionItems,
      actionHeaders,
      regenActionInput,
      downloadActionInput,
      importActionInput,
      finaliseActionInput,
      unfinaliseActionInput,

      coverPdfItems,
      coverPdfHeaders,
      uploadCoverPdf,

      importSection,
      finaliseVolume,
      unfinaliseVolume,

      preAllSections,
      downloadAllExcels,

      refreshTrigger,
      refresh,

      PERMISSIONS,
    };
  },
};
</script>

<style lang="less">
.volume-detail {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .sor-info-wrapper {
    flex: 0 0 auto;
    display: flex;

    .sor-info {
      flex: 1 1 0;
    }

    .sor-info-btns {
      flex: 0 0 auto;
      width: 200px;
    }
  }

  .sor-action-input-disable-row {
    background-color: rgba(238, 119, 122, 0.1);
  }

  .sor-finalised-div {
    border: solid 1px #5bc23f;
    border-radius: 12px;
    color: #5bc23f;
    background-color: rgba(91, 194, 63, 0.2);
    padding: 2px 8px;
    margin-left: 8px;
  }

  .sor-action-input-row,
  .sor-detail-section-title {
    background-color: #ffffff;
  }
}
</style>
